import { Loyalty_Provider_Type_Enum } from '@occc/graphql';

export const LOCATION_ATTRIBUTE_VALUE = {
  YES: 'YES',
  NO: 'NO',
};

export const TITLE_BY_LOYALTY_PROVIDER: Record<Loyalty_Provider_Type_Enum, string> = {
  [Loyalty_Provider_Type_Enum.OpenCommerce]: 'Activate',
  [Loyalty_Provider_Type_Enum.Albertsons]: 'Albertsons',
  [Loyalty_Provider_Type_Enum.Axonet]: 'Axonet',
};
